import { PageHeader } from '../../../components/PageHeader';
import { PageHeading } from 'components/PageHeading';
import { Breadcrumb } from 'components/Breadcrumb';
import { LinkCard } from 'components/Card';

export const FinancePage = () => {
  return (
    <>
      <PageHeader title="Financieel" />

      <PageHeading noMarginBottom leftSide={<Breadcrumb currentItem="Financieel" />} />

      <div className="p-7">
        <div className="grid gap-4 lg:grid-cols-3">
          <LinkCard title="Verkopen" to="sales" />
          <LinkCard title="Offertes" to="quotations" />
          <LinkCard title="Offerte aanvragen" to="quotation-requests" />
          <LinkCard title="Credit Notas" to="creditnotes" />
          <LinkCard title="Aankopen" to="purchases" />
          <LinkCard title="Ritoverzichten" to="ride-overviews" />
          <LinkCard title="Self billing" to="self-billing" />
          <LinkCard title="Debiteurenbeheer" to="payment-reminder" />
          <LinkCard title="Incasso" to="incasso" />
          <LinkCard title="Claims" to="claims" />
        </div>
      </div>
    </>
  );
};
